import { render, staticRenderFns } from "./FileViewerList.vue?vue&type=template&id=0976f5a7&scoped=true&"
import script from "./FileViewerList.vue?vue&type=script&lang=js&"
export * from "./FileViewerList.vue?vue&type=script&lang=js&"
import style0 from "./FileViewerList.vue?vue&type=style&index=0&id=0976f5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976f5a7",
  null
  
)

export default component.exports